import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const transferApi = createApi({
  reducerPath: 'transferApi',
  tagTypes: ['TransferCheck'],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('X-Token', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    checkTransferHistory: builder.mutation({
      query: ({ transaction_id }) => ({
        url: `/admin/check-transfer-history?transaction_id=${transaction_id}`,
        method: 'GET',
      }),
      invalidatesTags: ['TransferCheck'],
    }),
    subAccountTransfer: builder.mutation({
      query: ({ from_pk, to_pk, asset, amount }) => ({
        url: `/admin/sub-account-transfer?from_pk=${encodeURIComponent(from_pk)}&to_pk=${encodeURIComponent(to_pk)}&asset=${encodeURIComponent(asset)}&amount=${encodeURIComponent(amount)}`,
        method: 'POST',
      }),
    }),
    getSubAccountTransferHistory: builder.query({
      query: ({ page, limit }) => ({
        url: '/admin/sub-account-transfer',
        method: 'GET',
        params: { page_number: page, page_size: limit, order: 'desc' },
      }),
      transformResponse: (data) => ({
        list: data.history_list ?? [],
        count: data.page_amount ?? data.count ?? 0,
      }),
    }),
  }),
});

export const {
  useCheckTransferHistoryMutation,
  useSubAccountTransferMutation,
  useGetSubAccountTransferHistoryQuery,
} = transferApi;
